import $ from 'jquery';
var $gaTracking = $gaTracking || {};

$(document).ready(function () {
    $gaTracking.init();
});

$gaTracking = { 
    init: function () {
        if (typeof $$epiforms !== 'undefined') {
            $$epiforms(document).ready(function myfunction() {
                let emailTo = "";
                $$epiforms(".EPiServerForms").on("formsStartSubmitting", function (event) {
                    $($$epiforms(".EPiServerForms").prop('elements')).each(function(){
                        if ($(this).val().indexOf("@") !== -1) {
                            emailTo = $(this).val();
                        }
                    });
                });
                $$epiforms(".EPiServerForms").on("formsStepValidating", function (event) {
                    let currentForm = $$epiforms(this).get(0);
                    let $form = $(currentForm);
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $form.offset().top - $(window).height()/2
                    });
                });
                $$epiforms(".EPiServerForms").on("formsSubmitted", function (event) {
                    
                    if (event.isFinalizedSubmission && event.isSuccess) {
                        if (typeof window.dataLayer !== 'undefined') {
                            let currentForm = $$epiforms(this).get(0);
                            let $form = $(currentForm);
                            let $formId = $form.data('content-id');
                            let $formHostedPageId = $form.data('content-hosted-page-id');
                            let $formName = $form.data('content-name');
                            let pageUrl = window.location.href.replace('https://', '').replace('http://', '');

                            $gaTracking.pushForm($formId, $formName, $formHostedPageId, pageUrl, emailTo);
                        }
                    }
                });
            });
        }
    },
    pushForm: function (formId, formName, formHostedPageId, pageUrl, emailTo) {
        window.dataLayer.push({
            event: "formSubmit",
            leadForm: {
                formId: formId, // int -- content id of the form 
                formName: formName, // string -- Defined by form name
                formHostedPageId: formHostedPageId, // int -- PageId from the page that form was posted from
                pageURL: pageUrl, // string -- page url
                email: emailTo, // string -- email to
            }
        });
    }
};